import styles from "./desfazer-toast-detalhe.module.scss";
import type { DesfazerToastDetalheProps } from "./types-desfazer-toast-detalhe";

/** Detalhe do toast de remoção do wizard: o texto seguido do botão "Desfazer" (Figma: link sublinhado). */
export function DesfazerToastDetalheView({
  detalhe,
  rotulo,
  onDesfazer,
}: DesfazerToastDetalheProps) {
  return (
    <>
      {detalhe}
      <button type="button" className={styles.desfazer} onClick={onDesfazer}>
        {rotulo}
      </button>
    </>
  );
}
